// extracted by mini-css-extract-plugin
export var carouselContainer = "Carousel-module--carouselContainer--1MAN6";